export default __webpack_public_path__ + "static/media/Imp_hitch_cha.5f319dbc.svg";